import { useContext } from 'react';
import { TriggerGroupContext } from '../context/TriggerGroup';
export function useTriggerGroup() {
  var triggerGroup = useContext(TriggerGroupContext);

  if (triggerGroup == null) {
    return undefined;
  }

  return triggerGroup;
}